module.exports = __webpack_public_path__ + "static/media/afterAudio.711fd8d0.mp3";